import React from 'react';
import { motion } from 'framer-motion';

const REASONS = [
  {
    num: '01',
    title: 'Outcomes, not output',
    desc: 'We optimize for measurable business results — pipeline, revenue, retention — not deliverables.',
  },
  {
    num: '02',
    title: 'Senior team, no handoff',
    desc: 'The people who sold you the work are the people building it. No agency hot potato.',
  },
  {
    num: '03',
    title: 'Modern stack, modern speed',
    desc: 'We ship in days, not quarters. AI-native workflows mean leverage at every layer.',
  },
  {
    num: '04',
    title: 'Built to scale with you',
    desc: 'Architecture, automation, and ops designed for your year-three problems — not just today.',
  },
];

export const WhyEleva = () => {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 lg:py-40 px-6 lg:px-12 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20">
        {/* Sticky left */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-1.5 h-1.5 bg-brand-primary" />
              <span className="font-manrope text-xs uppercase tracking-[0.3em] text-white/60">
                02 — Why ELEVA
              </span>
            </div>
            <h2 className="font-outfit font-black tracking-tighter text-white text-6xl lg:text-8xl leading-[0.85]">
              Why<br /><span className="outline-text">ELEVA?</span>
            </h2>
            <p className="mt-8 font-manrope text-white/60 leading-relaxed max-w-md">
              Most agencies sell process. We sell results. Here&apos;s what&apos;s different
              when you partner with ELEVA Digital.
            </p>
          </div>
        </div>

        {/* Right list */}
        <div className="lg:col-span-7 flex flex-col gap-12 lg:gap-20">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`why-item-${i}`}
              className="border-t border-white/10 pt-8"
            >
              <span className="font-outfit font-black text-brand-primary text-6xl lg:text-7xl tracking-tighter leading-none">
                {r.num}
              </span>
              <h3 className="mt-6 font-outfit font-bold text-3xl lg:text-4xl text-white tracking-tight">
                {r.title}
              </h3>
              <p className="mt-4 font-manrope text-base lg:text-lg text-white/60 leading-relaxed max-w-xl">
                {r.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
